import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import { Layout, HardwareTable, AffiliateDisclosure, AutoCompleteTagInput } from '../components/common'
import { MetaData } from '../components/common/meta'
import { Pane, Button, ArrowRightIcon } from 'evergreen-ui';
import { currentMonth, currentMonthShort } from '../utils/constants';
import Img from 'gatsby-image'
import hardwareWalletsInfo from '../data/hardwareWalletsInfo.json';
import { Link } from '../components/common';
import { currentYear } from '../utils/constants';

/**
* Single page (/:slug)
*
* This file renders a single page and loads all the content.
*
*/

const HardwareWalletsPage = (props) => {
    const { pageContext, location } = props;
    let title = `Best Crypto Hardware / Cold Wallets of ${currentMonth} ${currentYear}`;
    let excerpt = `The best crypto hardware wallets / cold wallets of ${currentMonth} ${currentYear}. Comparison of the top non-custodial wallets to store your BTC, ETH, and other cryptocurrencies.`;
    let description = <span>The best crypto <Link to="/what-is-a-crypto-hardware-cold-wallet/">hardware wallets / cold wallets</Link> of {currentMonth} {currentYear}. Comparison of the top non-custodial wallets to store your BTC, ETH, and other cryptocurrencies.</span>;

    let filteredWallets;
    if (pageContext.title) {
        title = pageContext.title;
        const titleParts = title.split(' vs ');
        excerpt = `Comparison of ${pageContext.title}. Find the best crypto hardware wallet / cold wallet to store your cryptocurrencies.`
        description =  excerpt;
        filteredWallets = hardwareWalletsInfo.filter(wallet => titleParts.some(item => item === wallet.walletName));
    } else {
        filteredWallets = [...hardwareWalletsInfo];
    }
    
    const [wallets, setWallets] = useState(filteredWallets)
    
    // Read wallets from URL query parameter if present
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            const walletsParam = urlParams.get('wallets');
            if (walletsParam) {
                const walletNames = walletsParam.split('_').map(name => decodeURIComponent(name).replace(/-/g, ' '));
                const selectedWallets = hardwareWalletsInfo.filter(wallet => 
                    walletNames.includes(wallet.walletName)
                );
                if (selectedWallets.length > 0) {
                    setWallets(selectedWallets);
                    // Remove the wallets query parameter from URL
                    urlParams.delete('wallets');
                    const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams.toString()}` : '') + window.location.hash;
                    window.history.replaceState({}, '', newUrl);
                }
            }
        }
    }, [location]);


    const page = { meta_title: title, title, excerpt, description: excerpt };
    const newData = { ghostPage: page };
    const metaImage = 'https://www.cefirates.com/images/hardware-wallets/best-crypto-hardware-cold-wallets.png'

    return (
        <>
            <MetaData
                data={newData}
                location={location}
                type="website"
                image={metaImage}
            />
            <Helmet>
                <style type="text/css">{`${page.codeinjection_styles}`}</style>
            </Helmet>
            <Layout location={location}>
                <div className="container">
                    <article className="content">
                        <figure className="post-feature-image">
                            <Pane marginX="auto" maxWidth={720}>
                            <img src="/images/hardware-wallets/best-crypto-hardware-cold-wallets.png" />
                            </Pane>
                        </figure>
                        <Pane className="content-title image-heading-container">
                            <h1 className="image-heading">{title}</h1>
                        </Pane>
                        <section className="content-body load-external-scripts post-card-excerpt">{description}</section>
                        <AutoCompleteTagInput wallets={wallets} setWallets={setWallets} />
                        <HardwareTable wallets={wallets} />
                        <AffiliateDisclosure />
                        {/* <Pane display="flex" justifyContent="center" gap={16}>
                            <Link to="/all-hardware-wallet-comparisons/">
                                <Button color="#3366FF" size="large" appearance="minimal" iconAfter={ArrowRightIcon}>
                                    All Hardware Wallet Comparisons
                                </Button>
                            </Link>
                        </Pane> */}
                    </article>
                </div>
            </Layout>
        </>
    )
}

export default HardwareWalletsPage;

// export const postQuery = graphql`
//     query($slug: String!) {
//         ghostPage(slug: { eq: $slug }) {
//             ...GhostPageFields
//         }
//     }
// `
